export const GET_REPORTS_LIST_SUCCESS = 'GET_REPORTS_LIST_SUCCESS';
